









































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import marked from 'marked';

import { Poi, PoiArExperience } from '@/models/poi';
import { ArExperienceChoices } from '@/constants';
import UnityBridge from '@/unity-bridge';

@Component
export default class PoiDetailArPage extends Vue {

    @Prop(String) public poiId: string;
    @Prop(Object) public model: PoiArExperience;

    private arExperience: PoiArExperience = null;
    private poi: Poi = {} as Poi;
    private unityBridge: UnityBridge = null;
    private arSupported: boolean = true;

    get onboardingText() {
        if (!this.arExperience) return undefined;
        return marked(this.arExperience.onboarding);
    }

    get showInteractionIcons(): boolean {
        if (!this.arExperience) return true;
        return this.arExperience.experience === ArExperienceChoices.SCHLOSS_VADUZ ||
            this.arExperience.experience === ArExperienceChoices.BURG_GUTENBERG ||
            this.arExperience.experience === ArExperienceChoices.KASTELL_SCHAN;
    }

    get showBuildingIcons(): boolean {
        if (!this.arExperience) return true;
        return this.arExperience.experience === ArExperienceChoices.BURG_BUILDER;
    }

    get showSequenceIcons(): boolean {
        if (!this.arExperience) return true;
        return this.arExperience.experience === ArExperienceChoices.UEBERFLUTUNG;
    }

    get showStoryIcons(): boolean {
        if (!this.arExperience) return true;
        return this.arExperience.experience === ArExperienceChoices.GERICHT ||
            this.arExperience.experience === ArExperienceChoices.TORFSTECHER ||
            this.arExperience.experience === ArExperienceChoices.WEBSTUHL;
    }

    public async created() {
        await this.$store.waitUntilReady();
        this.poi = this.$store.getPoi(parseInt(this.poiId, 10));

        if (this.model) {
            this.arExperience = this.model;
        } else {
            if (this.poi.content_ar_experiences && this.poi.content_ar_experiences.length > 0) {
                this.arExperience = this.poi.content_ar_experiences[0];
            }
        }

        this.TryToClaimBadgeOnNonArIfPossible();
    }

    public mounted() {
        this.unityBridge = new UnityBridge();
        this.unityBridge.addMessageHandler('arStatus', e => this.OnArStatus(e));
        this.unityBridge.send('checkArAvailability');
    }

    public beforeDestroy() {
        this.unityBridge.destroy();
    }

    public OnArStatus(event: any) {
        this.arSupported = event.detail === 'AVAILABLE';

        this.TryToClaimBadgeOnNonArIfPossible();
    }

    private TryToClaimBadgeOnNonArIfPossible() {
        if (!this.arSupported && this.arExperience && this.arExperience.experience) {
            // claim the ar started badgae for people with non ar devices
            // otherwise they can not claim all badges
            this.$store.saveSceneStarted(this.arExperience.experience);
        }
    }

    public async openUnityScene(checkIfUserHasSeenManual: string) {

        const sheet = this.$refs.manualSheet as any;

        if (checkIfUserHasSeenManual === 'checkIfUserHasSeenManual'
            && this.$store.arOnBoardingManualVisits <= 3) { // user has to see the manual at least 3 times!!!

            sheet.open(true);

            this.$store.arOnBoardingManualVisits += 1;
            await this.$store.saveArOnBoardingManualVisits();

        } else {
            // claim the ar started badgae
            this.$store.saveSceneStarted(this.arExperience.experience);

            // Close Sheet
            sheet.close(true);

            // set language in unity
            this.unityBridge.send('setLanguage', this.$store.settings.language);

            // start a ar scene
            switch (this.arExperience.experience) {
                case ArExperienceChoices.MAP_LIECHTENSTEIN:
                    this.unityBridge.send('launchArScene', 'AR_M01_Liechtenstein_Map');
                    break;
                case ArExperienceChoices.SCHLOSS_VADUZ:
                    this.unityBridge.send('launchArScene', 'AR_I01_Vaduz_Schloss');
                    break;
                case ArExperienceChoices.BURG_GUTENBERG:
                    this.unityBridge.send('launchArScene', 'AR_I02_Balzers_Burg');
                    break;
                case ArExperienceChoices.KASTELL_SCHAN:
                    this.unityBridge.send('launchArScene', 'AR_I03_Schaan_Kastell');
                    break;
                case ArExperienceChoices.KIRCHE_BENDERN:
                    this.unityBridge.send('launchArScene', 'AR_T01_Bendern_Kirche');
                    break;
                case ArExperienceChoices.WEBSTUHL:
                    this.unityBridge.send('launchArScene', 'AR_S03_Triesen_Webstuhl');
                    break;
                case ArExperienceChoices.TORFSTECHER:
                    this.unityBridge.send('launchArScene', 'AR_S02_Ruggell_Torstecher');
                    break;
                case ArExperienceChoices.GERICHT:
                    this.unityBridge.send('launchArScene', 'AR_S01_Eschen_Gerichtsverhandlung');
                    break;
                case ArExperienceChoices.UEBERFLUTUNG:
                    this.unityBridge.send('launchArScene', 'AR_T02_Mauren_Ueberflutung');
                    break;
                case ArExperienceChoices.BURG_BUILDER:
                    this.unityBridge.send('launchArScene', 'AR_B01_Schellenberg_Burg_Builder');
                    break;
            }

            // Google Anlaytics event
            this.$ga.event({
                eventCategory: 'poi',
                eventAction: 'startAR',
                eventLabel: this.arExperience.experience,
            });
        }
    }
}
